/* eslint-disable @typescript-eslint/prefer-literal-enum-member */
/* eslint-disable @typescript-eslint/no-namespace */
import type {
  FilterInputType as EFilterInputType,
  getMakeSearch_makeSearch_category as IGetMakeSearch_makeSearch_category,
} from '../../../shared/types/apollo';
import type { Product } from '../../../shared/types/product';

export namespace Sidebar {
  export enum EFilterType {
    RANGED_VALUE = 'RANGED_VALUE',
    MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
    MULTIPLE_CHOICE_TAG = 'MULTIPLE_CHOICE_TAG',
  }

  export enum ETypeFromBack {
    RANGED_VALUE = 'RV',
    MULTIPLE_CHOICE = 'MC',
    MULTIPLE_CHOICE_TAG = 'MCT',
  }

  export enum ETypeFromFront {
    RV = EFilterType.RANGED_VALUE,
    MC = EFilterType.MULTIPLE_CHOICE,
    MCT = EFilterType.MULTIPLE_CHOICE_TAG,
  }

  export type ShortUrlType =
    | ETypeFromBack.RANGED_VALUE
    | ETypeFromBack.MULTIPLE_CHOICE
    | ETypeFromBack.MULTIPLE_CHOICE_TAG;

  export enum EOrder {
    default = '',
    ascending = 'ascending',
    descending = 'descending',
  }

  export enum ESort {
    default = '',
    price = 'price',
    rating = 'rating',
    date = 'date',
    orders = 'orders',
  }

  export enum EPageType {
    SEARCH_PAGE = 'SEARCH_PAGE',
    SHOP_PAGE = 'SHOP_PAGE',
    CATEGORY_PAGE = 'CATEGORY_PAGE',
    CATEGORY_PAGE_COLLECTION = 'CATEGORY_PAGE_COLLECTION',
    WISHES_PAGE = 'WISHES_PAGE',
  }

  export enum EFilterEvent {
    CATEGORY = 'CATEGORY',
    SORT = 'SORT',
    FILTER = 'FILTER',
    ALL = 'ALL',
  }

  export enum EModalLevel {
    FIRST = 'FIRST',
    SECOND = 'SECOND',
  }

  export enum ERangeType {
    minRange = 'minRange',
    maxRange = 'maxRange',
  }

  export interface IAsideStyle {
    marginTop?: string;
    top?: string;
    position?: string;
  }

  export interface IMultipleListValue {
    count: number;
    id: number;
    image?: string;
    name: string;
    isChecked?: boolean;
  }

  export interface IFilter {
    description?: string;
    filterType: EFilterType;
    id: number;
    max?: number;
    min?: number;
    title?: string;
    values?: Array<IMultipleListValue>;
    maxCurrent?: any;
    minCurrent?: any;
    minBase?: number;
    maxBase?: number;
    timeout?: number;
    isActive: boolean;
    measurementUnit: string;
  }

  export interface IUrlFilter {
    id: number;
    filter: number[];
    filterType: EFilterType;
    urlFilter: string;
  }

  export interface IUrlFilterMobile {
    id: number;
    filter: number[];
    filterType: EFilterInputType;
    urlFilter: string;
  }

  export interface ISidebarFilter {
    sorting: ESort;
    appliedFilters?: Array<IFilter>;
    skuFiltersList?: Array<IFilter>;
    ordering?: EOrder;
    totalProducts?: number;
    selectedFilters?: string;
    modifiedSelectedFilters?: string;
    shopId?: number;
    currentCategoryId?: number;
    discount?: boolean;
    filters?: IFilter[];
    currentPage?: number;
  }

  export interface ICategorySidebar {
    id: string | number;
    parents: Product.Category[];
    lastCategoryWithChildren: Product.Category;
    pageType: EPageType;
    currentCategory: number;
    rid?: string;
    offerCategory?: string;
    offerCategoryTitle?: string;
    link?: string;
    query?: string;
    categoryFullMatch?: boolean;
    category?: IGetMakeSearch_makeSearch_category;
    token: string;
  }

  export interface IFiltersGroup {
    skuFiltersSelected: string;
    skuFilterList: Array<IFilter>;
  }

  export interface ISelectedFilters {
    selectedFilters?: IFiltersGroup;
    id?: number;
    title?: string;
    type?: EFilterEvent;
    ordering?: EOrder;
    sorting?: string;
  }

  export interface Modal {
    modal: EModalLevel;
  }

  export interface ICategoryCrumb {
    adult: boolean;
    children: Array<ICategoryCrumb>;
    eco?: boolean;
    iconLink: string;
    id: number;
    path: number[];
    productAmount: number;
    title: string;
    seoHeader: string;
    seoMetaTag: string;
    parent?: {
      id: number;
      title?: string;
    };
  }

  export interface ICategoryTree {
    category: ICategoryCrumb;
    selectedCategory: {
      id: number;
      path: number[];
    };
  }

  export interface IMobileFilterSettings {
    categoryId: string;
    categoryTitle: string;
    filters: string;
    ordering?: string;
    sorting?: string;
    shopTitle?: string;
    query?: string;
    subCategoryId?: string;
    pageSize: string;
    page: string;
    limit: number;
    offset: number;
    minPrice?: number;
    maxPrice?: number;
    showAdult?: boolean;
    shopId: number;
  }

  export type TFilterMobileSettings = Partial<Record<keyof Sidebar.IMobileFilterSettings, string>>;
}
